import { Question } from '../types/assessment';

export const demographicsQuestions: Question[] = [
  {
    id: 'demo_age',
    text: 'What is your age?',
    type: 'multiple-choice',
    category: 'demographics',
    required: true,
    options: [
      { value: '13-17', label: '13-17 years old' },
      { value: '18-24', label: '18-24 years old' },
      { value: '25-34', label: '25-34 years old' },
      { value: '35-44', label: '35-44 years old' },
      { value: '45-54', label: '45-54 years old' },
      { value: '55-64', label: '55-64 years old' },
      { value: '65+', label: '65+ years old' }
    ]
  },
  {
    id: 'demo_gender',
    text: 'What is your gender?',
    type: 'multiple-choice',
    category: 'demographics',
    required: true,
    options: [
      { value: 'female', label: 'Female' },
      { value: 'male', label: 'Male' },
      { value: 'prefer-not-to-say', label: 'Prefer not to say' }
    ]
  },
  {
    id: 'demo_relationship_status',
    text: 'What is your current relationship status?',
    type: 'multiple-choice',
    category: 'demographics',
    required: true,
    options: [
      { value: 'single', label: 'Single' },
      { value: 'dating', label: 'Dating/In a relationship' },
      { value: 'married', label: 'Married' },
      { value: 'domestic-partnership', label: 'Domestic partnership/Civil union' },
      { value: 'separated', label: 'Separated' },
      { value: 'divorced', label: 'Divorced' },
      { value: 'widowed', label: 'Widowed' }
    ]
  },
  {
    id: 'demo_education',
    text: 'What is your highest level of education completed?',
    type: 'multiple-choice',
    category: 'demographics',
    required: true,
    options: [
      { value: 'some-high-school', label: 'Some high school' },
      { value: 'high-school', label: 'High school diploma/GED' },
      { value: 'some-college', label: 'Some college' },
      { value: 'associates', label: "Associate's degree" },
      { value: 'bachelors', label: "Bachelor's degree" },
      { value: 'masters', label: "Master's degree" },
      { value: 'doctoral', label: 'Doctoral degree' },
      { value: 'professional', label: 'Professional degree (MD, JD, etc.)' }
    ]
  },
  {
    id: 'demo_employment',
    text: 'What is your current employment status?',
    type: 'multiple-choice',
    category: 'demographics',
    required: true,
    options: [
      { value: 'full-time', label: 'Employed full-time' },
      { value: 'part-time', label: 'Employed part-time' },
      { value: 'self-employed', label: 'Self-employed' },
      { value: 'unemployed-seeking', label: 'Unemployed, seeking work' },
      { value: 'unemployed-not-seeking', label: 'Unemployed, not seeking work' },
      { value: 'student', label: 'Student' },
      { value: 'retired', label: 'Retired' },
      { value: 'disabled', label: 'Unable to work due to disability' },
      { value: 'homemaker', label: 'Homemaker/Stay-at-home parent' }
    ]
  },
  {
    id: 'demo_living_situation',
    text: 'What is your current living situation?',
    type: 'multiple-choice',
    category: 'demographics',
    required: true,
    options: [
      { value: 'alone', label: 'Live alone' },
      { value: 'family', label: 'Live with family members' },
      { value: 'partner-spouse', label: 'Live with partner/spouse' },
      { value: 'roommates', label: 'Live with roommates/friends' },
      { value: 'group-home', label: 'Group home or assisted living' },
      { value: 'homeless', label: 'Currently homeless' },
      { value: 'other', label: 'Other living arrangement' }
    ]
  },
  {
    id: 'demo_children',
    text: 'Do you have children?',
    type: 'multiple-choice',
    category: 'demographics',
    required: true,
    options: [
      { value: 'no', label: 'No children' },
      { value: 'yes-minors', label: 'Yes, children under 18' },
      { value: 'yes-adults', label: 'Yes, adult children only' },
      { value: 'yes-both', label: 'Yes, both minor and adult children' }
    ]
  },
  {
    id: 'demo_primary_language',
    text: 'What is your primary language?',
    type: 'multiple-choice',
    category: 'demographics',
    required: true,
    options: [
      { value: 'english', label: 'English' },
      { value: 'spanish', label: 'Spanish' },
      { value: 'chinese', label: 'Chinese (Mandarin/Cantonese)' },
      { value: 'french', label: 'French' },
      { value: 'arabic', label: 'Arabic' },
      { value: 'hindi', label: 'Hindi' },
      { value: 'portuguese', label: 'Portuguese' },
      { value: 'russian', label: 'Russian' },
      { value: 'japanese', label: 'Japanese' },
      { value: 'korean', label: 'Korean' },
      { value: 'other', label: 'Other' }
    ]
  }
]; 